import { AfterViewInit, Component } from "@angular/core";

@Component({
  selector: "nis-caption-editor",
  templateUrl: "./caption-editor.component.html",
  styles: [
    `
      :host ::ng-deep .listing-field {
        display: inline;
        cursor: pointer;
        padding: 4px;
        border-radius: 2px;
      }
      :host ::ng-deep .listing-field:hover {
        background-color: #efefef;
      }
      :host ::ng-deep .listing-field:hover .listing-field-button {
        display: inline;
      }
      :host ::ng-deep .listing-field-button {
        display: none;
        margin: 0 2px;
        cursor: pointer;
      }
      :host ::ng-deep .listing-field-button:hover {
        transform: scale(1.2);
      }
      .fr-popup.fr-active {
        display: none;
      }
    `,
  ],
})
export class CaptionEditorComponent implements AfterViewInit {
  html: string;
  froalaOptions: Object = {
    key: "RB3J4B17C10iB6E5E4H5I2I3A6B6C5C4C-11NGNe1IODMGYNSFKV==",
    toolbarButtons: [
      "fontFamily",
      "fontSize",
      "lineHeight",
      "align",
      "color",
      "|",
      "bold",
      "italic",
      "underline",
    ],
    iconsTemplate: "font_awesome_5",
    colorsText: [
      "#e6292f",
      "#fd6721",
      "#fff64a",
      "#52d15d",
      "#81b5e5",
      "#4253bd",
      "#6d41a0",
      "#fdcdd5",
      "#b97957",
      "#777777",
      "#ffffff",
      "#000000",
    ],
    colorsBackground: [
      "#e6292f",
      "#fd6721",
      "#fff64a",
      "#52d15d",
      "#81b5e5",
      "#4253bd",
      "#6d41a0",
      "#fdcdd5",
      "#b97957",
      "#777777",
      "#ffffff",
      "#000000",
      "REMOVE",
    ],
    fontSizeSelection: true,
    fontSize: [
      "6",
      "8",
      "9",
      "10",
      "11",
      "12",
      "14",
      "18",
      "24",
      "36",
      "42",
      "64",
      "128",
    ],
    fontSizeUnit: "px",
    colorsStep: 6,
    lineHeights: {
      Default: "",
      Single: "1",
      "1.1": "1.1",
      "1.2": "1.2",
      "1.3": "1.3",
      "1.4": "1.4",
      "1.5": "1.5",
      "1.6": "1.6",
      "1.7": "1.7",
      "1.8": "1.8",
      Double: "2",
      "2.25": "2.25",
      "2.5": "2.5",
      "2.75": "2.75",
      Triple: "3",
    },
    immediateAngularModelUpdate: true,
    colorsHEXInput: true,
    charCounterCount: false,
    fontFamilySelection: true,
    imageAllowedTypes: ["jpeg", "jpg", "png"],
    imageMaxSize: 1024 * 1024 * 2, // 2 MB
    imageDefaultWidth: 20,
    imageDefaultDisplay: "inline",
    imageOutputSize: true,
    imageEditButtons: ["imageReplace", "imageAlign", "imageRemove"],
    imageInsertButtons: ["imageBack", "|", "imageUpload", "imageByURL"],
    imageStyles: {},
    placeholderText: "",
    tableColors: [
      "#e6292f",
      "#fd6721",
      "#fff64a",
      "#52d15d",
      "#81b5e5",
      "#4253bd",
      "#6d41a0",
      "#fdcdd5",
      "#b97957",
      "#777777",
      "#ffffff",
      "#000000",
    ],
    formEditButtons: [],
    zIndex: 10000,
    imageUploadToS3: {
      bucket: "elasticbeanstalk-us-east-1-462591887108",
      // Your bucket region.
      region: "s3-us-east-1",
      keyStart: "uploads/",
      params: {
        acl: "public-read", // ACL according to Amazon Documentation.
        AWSAccessKeyId: "AKIAJ26WPZPOLYFRHDRA", // Access Key from Amazon.
        policy: "POLICY_STRING", // Policy string computed in the backend.
        signature: "", // Signature computed in the backend.
      },
    },
    tableStyles: {
      "fr-solid-borders": "Solid Borders",
    },
    tableCellStyles: {
      "fr-solid-borders": "Solid Borders",
    },
    height: 150,
    toolbarInline: false,
    editInPopup: false,
    toolbarVisibleWithoutSelection: false,
    events: {
      click: function (clickEvent) {
        // Do something here.
        // this is the editor instance.
        alert("here");
        console.log(this, clickEvent);
      },
      // "froalaEditor.contentChanged": () => {
      //   this.zone.run(() => {
      //     this.checkFieldPresence();
      //   });
      // },
      // 'froalaEditor.focus': () => {
      //   this.zone.run(() => {
      //     this.displayButtons = true;
      //   });
      // },
      // 'froalaEditor.blur': () => {
      //   this.zone.run(() => {
      //     this.displayButtons = false;
      //   });
      // }
    },
  };
  htmlEditor: any;
  initializeFroala(initControls) {
    this.htmlEditor = initControls.getEditor();
    initControls.initialize();
  }
  ngAfterViewInit() {
    // Use event delegation to handle clicks on dynamically added buttons
    document.addEventListener("click", (event) => {
      const target = event.target as HTMLElement;
      if (target && target.classList.contains("listing-field-delete")) {
        this.onListingFieldDeleteClick(target);
      } else if (target && target.classList.contains("listing-field-edit")) {
        this.onListingFieldEditClick(target);
      }
    });
  }

  addTag() {
    this.htmlEditor(
      "html.insert",
      '<span contenteditable="false" class="listing-field">tag<i class="listing-field-button listing-field-edit fa fa-pencil"></i><i class="listing-field-button listing-field-delete fa fa-times"></i></span>'
    );

    this.html = this.htmlEditor("html.get");
  }

  onListingFieldDeleteClick(button: HTMLElement) {
    const tagElement = button.closest(".listing-field");
    if (tagElement) {
      tagElement.remove();
      this.html = this.htmlEditor("html.get");
    }
  }

  onListingFieldEditClick(button: HTMLElement) {}
}
